import React, {useState, useEffect, useCallback, createContext, useContext} from 'react';
import {HookFormAutocomplete, MyTypography} from '../../common/components';
import {Stack, Chip} from '@mui/material';

const ClinicTagsAutocompleteContext = createContext();

export function ClinicTagsAutocompleteProvider({ tags, children }) {
    const [immutableTags, setImmutableTags] = useState([]);

    useEffect(() => {
        if (Array.isArray(tags) && tags.length > 0) {
            setImmutableTags(tags.filter(t => t.immutable).map(t => t.tag));
        }
        return () => {
            setImmutableTags([]);
        };
    }, [tags]);

    return (
        <ClinicTagsAutocompleteContext.Provider value={{ immutableTags }}>
            {children}
        </ClinicTagsAutocompleteContext.Provider>
    );
}

export default function ClinicTagsHookFormAutocomplete({prefix, control, errors, schema, placeholder="Enter clinic tags/aliases", label="Clinic tags/aliases"}) {
    const {immutableTags} = useContext(ClinicTagsAutocompleteContext);

    const renderTags = useCallback((value, getTagProps) => {
        if (!value) {
            return value;
        }
        return value.map((option, index) => {
            const tagProps = {...getTagProps({ index })};

            if (immutableTags.includes(option)) {
                tagProps['onDelete'] = null;
                tagProps['sx'] = {display:'none'};
            }

            return (<Chip variant="outlined" label={option.toLowerCase()}  {...tagProps} />);
        });
    }, [immutableTags]);

    return (
        <Stack direction="column" spacing={0.5}>
            <HookFormAutocomplete
                id={schema}
                name={schema}
                placeholder={placeholder}
                label={label}
                schema={schema}
                prefix={prefix}
                control={control}
                errors={errors}
                autocompleteProps={{
                    includeInputInList: true,
                    multiple: true,
                    freeSolo: true,
                    fullWidth: true,
                    disableClearable: true,
                    renderTags,
                }}
                options={[]}
            />
            <MyTypography variant="caption">Note: To add tags, Click the input box to focus then Enter the value then hit "Enter".</MyTypography>
        </Stack>
    );
}
